<template>
  <div class="mod-purchase-inquiry">
    <el-form :inline="true" :model="dataForm" @keyup.enter.native="pageIndex = 1; getDataList()">
      <el-form-item label="询价单号">
        <el-input v-model="dataForm.inquiryCode" size="small" clearable />
      </el-form-item>
      <el-form-item label="审核">
        <el-select v-model="dataForm.approveStatus" clearable size="small" style="width:100px">
          <el-option label="未审" value="0" />
          <el-option label="已审" value="2" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button v-if="isAuth('purchase:purchaseInquiry:list')" type="primary" size="small" @click="pageIndex = 1; getDataList()">查询</el-button>
      </el-form-item>
      <el-form-item>
        <el-button v-if="isAuth('purchase:purchaseInquiry:save')" type="primary" size="small" @click="addOrUpdateHandle()">新增</el-button>
      </el-form-item>
    </el-form>

    <el-table :data="dataList" border v-loading="dataListLoading" :header-cell-style="{ background: '#f5f7fa', color: '#606266' }">
      <el-table-column type="index" label="序号" width="60" header-align="center" align="center" />
      <el-table-column prop="inquiryCode" label="询价单号" min-width="140" header-align="center" align="left">
        <template slot-scope="scope">
          <a v-if="isAuth('purchase:purchaseInquiry:info')" class="code-link" @click="addOrUpdateHandle(scope.row.inquiryId, true)">{{ scope.row.inquiryCode }}</a>
          <span v-else>{{ scope.row.inquiryCode }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="inquiryDate" label="询价日期" width="110" header-align="center" align="center">
        <template slot-scope="scope">{{ (scope.row.inquiryDate || '').slice(0, 10) }}</template>
      </el-table-column>
      <el-table-column prop="totalQuantity" label="询价数量" width="100" header-align="center" align="right" />
      <el-table-column prop="approveStatus" label="审核" width="90" header-align="center" align="center">
        <template slot-scope="scope">
          <el-tag :type="workflowStatusTagType(scope.row.workflowStatus, scope.row.approveStatus)" size="small">
            {{ workflowStatusText(scope.row.workflowStatus, scope.row.approveStatus) }}
          </el-tag>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      @size-change="val => { pageSize = val; pageIndex = 1; getDataList() }"
      @current-change="val => { pageIndex = val; getDataList() }"
      :current-page="pageIndex"
      :page-sizes="[20, 50, 100]"
      :page-size="pageSize"
      :total="totalPage"
      layout="total, sizes, prev, pager, next, jumper"
    />

    <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList" @convert-po="convertPoHandle" />
    <convert-po v-if="convertPoVisible" ref="convertPo" @success="getDataList" />
  </div>
</template>

<script>
import AddOrUpdate from './purchaseInquiry-add-or-update'
import ConvertPo from './purchaseInquiry-convert-po'
import request from '../../api/request'
import { fetchPerms } from '../../api/auth'
import { workflowStatusText, workflowStatusTagType } from '../../utils/workflow'

export default {
  name: 'PurchaseInquiry',
  components: { AddOrUpdate, ConvertPo },
  data() {
    return {
      dataForm: { inquiryCode: '', approveStatus: '' },
      dataList: [],
      pageIndex: 1,
      pageSize: 20,
      totalPage: 0,
      dataListLoading: false,
      addOrUpdateVisible: false,
      convertPoVisible: false,
      permCodes: []
    }
  },
  created() { this.loadPerms(); this.getDataList() },
  activated() { this.getDataList() },
  methods: {
    workflowStatusText,
    workflowStatusTagType,
    isAuth(perm) {
      const user = this.$store.state.user || {}
      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []
      const role = String(user.roleCode || '')
      if (role === 'TENANT_ADMIN' || role === 'PLATFORM_ADMIN' || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true
      return this.permCodes.indexOf(perm) >= 0
    },
    loadPerms() { fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {}) },
    getDataList() {
      this.dataListLoading = true
      request.post('/purchase/purchaseInquiry/list', {
        currentPage: this.pageIndex,
        pageSize: this.pageSize,
        code: this.dataForm.inquiryCode,
        status: this.dataForm.approveStatus,
        approveStatus: this.dataForm.approveStatus
      }).then(res => {
        const body = res.data || {}
        this.dataList = body.list || []
        this.totalPage = body.totalCount || 0
      }).catch(() => {}).finally(() => { this.dataListLoading = false })
    },
    addOrUpdateHandle(id, readonly) {
      this.addOrUpdateVisible = true
      this.$nextTick(() => this.$refs.addOrUpdate.init(id, readonly))
    },
    convertPoHandle(row) {
      if (!row || !row.inquiryId) return
      this.convertPoVisible = true
      this.$nextTick(() => this.$refs.convertPo.init(row.inquiryId, row.inquiryCode))
    },
    open(id, readonly) { this.addOrUpdateHandle(id, !!readonly) }
  }
}
</script>

<style scoped>
.code-link { cursor: pointer; color: #348adb; }
</style>
